let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("4DsoW")]).then(() => parcelRequire('4CgFO'));